import React from 'react'
import { Typography } from 'antd'

const { Title } = Typography

export interface HeadingProps {
  /** 1 = largest (page title) down to 5 = smallest heading style. Sizes come from the antd theme's fontSizeHeading1-5 tokens (see ThemeSetting.tsx `fontSize.h1`-`h5`). */
  level: 1 | 2 | 3 | 4 | 5
  children: React.ReactNode
  style?: React.CSSProperties
  /** Escape hatch for callers with existing CSS keyed off a class, same pattern as TextField/Text. */
  className?: string
}

/**
 * Vacation Tracker's single heading component. Wraps antd `Typography.Title`,
 * replacing ad hoc `<Title level={n}>` usage across settings/report pages.
 */
export function Heading({ level, children, style, className }: HeadingProps) {
  return (
    <Title level={level} style={style} className={className}>
      {children}
    </Title>
  )
}

export default Heading
